import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { globalVariables } from '../../globalVariables';


const axiosApiCall = axios.create({
  baseURL: globalVariables.alt360APIUrl
});

const axiosPalantirApiCall = axios.create({
  baseURL: globalVariables.palintrAPIUrl
});

// Request interceptor for adding the bearer token
axiosApiCall.interceptors.request.use(
  (config) => {
    // Token
    if (sessionStorage.getItem("bearer-token")) {
      config.headers.Authorization = `Bearer ${sessionStorage.getItem("bearer-token")}`;
    }
    config.headers['loggedinExtEntraUserID'] = secureLocalStorage.getItem("tenantUserId");
    config.headers['userID'] = secureLocalStorage.getItem("userId");
    config.headers['x-api-key'] = 'dev-key-123';
    return config;
  },
  (error) => {
    return Promise.reject(error);

  }
);

axiosPalantirApiCall.interceptors.request.use(
  (config) => {
    // Token
    if (sessionStorage.getItem("bearer-token")) {
      config.headers.Authorization = `Bearer ${sessionStorage.getItem("bearer-token")}`;
    }
    config.headers['loggedinExtEntraUserID'] = secureLocalStorage.getItem("tenantUserId");
    config.headers['userID'] = secureLocalStorage.getItem("userId");
    config.headers['x-api-key'] = 'dev-key-123';
    return config;
  },
  (error) => {
    return Promise.reject(error);

  }
);

export const axiosPalantirApi = axiosPalantirApiCall;
// Export the api instance
export default axiosApiCall;